export class EvaluacionAlumno {
    periodoevaluacionid: number = 0;
    periodoevaluacion: string = "";
    departamento: string = "";
    nombre: string = "";
    tipoplantillaid:number = 0;
    gradoid: number = 0;
    nivelid: number = 0;
    grupoid: number = 0;
    materiaid: number = 0;
    puesto: string = "";
    materia: string = "";
    urlfotografia: string = "";
    evaluadorid: number = 0;
    puestoid: number = 0;
    tipovisualizacioncompetenciacriterioid:number = 0;
    tipovisualizacionpreguntaid:number = 0;
    tipovisualizacionrespuestaid:number = 0;

    constructor(init?: Partial<EvaluacionAlumno>) {
        Object.assign(this, init);
    }
}
